// Custom scripts.

document.addEventListener('DOMContentLoaded', () => {
  // Toggle product card's secondary image on hover
  let secondaryMediaHoverTimer;

  function initSecondaryMediaHover() {
    document.querySelectorAll('[data-pd-color-swatch] .color-swatch:not(.pd-color-swatch-hover)').forEach((el) => {
      el.classList.add('pd-color-swatch-hover');

      el.addEventListener('mouseenter', (event) => {
        clearTimeout(secondaryMediaHoverTimer);
        event.target.classList.add('pd-color-swatch-hover--active');
        event.target.closest('.product-card').querySelector('secondary-media')?.carousel?.select(event.target.parentElement.dataset.index);
      });

      el.addEventListener('mouseleave', (event) => {
        event.target.classList.remove('pd-color-swatch-hover--active');
        secondaryMediaHoverTimer = setTimeout(() => {
          event.target.closest('.product-card').querySelector('secondary-media')?.carousel?.select(0);
        }, 200);
      });
    });
  }

  initSecondaryMediaHover();

  // Re-initialize Yotpo Star widgets
  document.querySelectorAll('pd-product-recommendations').forEach((el) => {
    el.addEventListener('recommendations:loaded', () => {
      yotpoWidgetsContainer.initWidgets();
      initSecondaryMediaHover();
    });
  });

  document.querySelectorAll('recently-viewed').forEach((el) => {
    el.addEventListener('recentlyViewed:loaded', () => {
      yotpoWidgetsContainer.initWidgets();
      initSecondaryMediaHover();
    });
  });

  // Toggle Yotpo Rewards Bar color scheme
  new MutationObserver((mutationList, observer) => {
    for (const mutation of mutationList) {
      if (
        mutation.type === 'childList' &&
        mutation.addedNodes.length === 1 &&
        mutation.addedNodes[0].nodeType === Node.ELEMENT_NODE &&
        mutation.addedNodes[0].matches('.yotpo-banner-layout.yotpo-banner-low')
      ) {
        const footerGroup = document.querySelector('footer-group');
        const rewardsBar = document.querySelector('.yotpo-widget-loyalty-floater-widget .yotpo-banner-layout.yotpo-banner-low');

        function toggleMode() {
          if (rewardsBar.getBoundingClientRect().y > footerGroup.getBoundingClientRect().y) {
            rewardsBar.classList.add('pd-alt-color');
          } else {
            rewardsBar.classList.remove('pd-alt-color');
          }
        }

        window.addEventListener('scroll', toggleMode);
        window.addEventListener('resize', toggleMode);
        toggleMode();

        // Show user's reward points
        const topbarBtn = document.querySelector('.pd-topbar-rewards__btn');

        if (topbarBtn) {
          topbarBtn.textContent = rewardsBar.innerText;
          topbarBtn.addEventListener('click', (event) => {
            event.preventDefault();
            rewardsBar.click();
          });
        }

        observer.disconnect();
      }
    }
  }).observe(document.body, { subtree: true, childList: true });

  // Add `.0` to Yotpo scores with whole numbers
  new MutationObserver((mutationList, observer) => {
    for (const mutation of mutationList) {
      if (
        mutation.type === 'childList' &&
        mutation.addedNodes.length === 1 &&
        mutation.addedNodes[0].nodeType === Node.ELEMENT_NODE &&
        mutation.addedNodes[0].matches('.yotpo-reviews-star-ratings-widget')
      ) {
        const score = mutation.addedNodes[0].querySelector('.yotpo-sr-bottom-line-score');
        if (score && score.innerText.indexOf('.') === -1) {
          score.innerText = `${score.innerText.trim()}.0`;
        }
      }
    }
  }).observe(document.body, { subtree: true, childList: true });

  // Open first footer accordion on mobile.
  if (window.innerWidth <= 768) {
    const firstFooterAccordion = document.querySelector('.footer__accordions > details:first-of-type');
    firstFooterAccordion.setAttribute('open', '');
    firstFooterAccordion.setAttribute('aria-expanded', 'true');
    firstFooterAccordion.setAttribute('style', 'overflow: visible; height: auto;');
  }

  // Toggle BIS button on Quick View.
  document.addEventListener('change', (event) => {
    if (!event.target.matches('input[name="id"]') || !event.target.parentElement.querySelector('.BIS_trigger')) return;

    const bisButton = event.target.parentElement.querySelector('.BIS_trigger');
    const product = JSON.parse(bisButton.dataset.productData);
    const variant = product.variants.find((variant) => variant.id === parseInt(event.target.value));

    if (variant && variant.available) {
      bisButton.removeAttribute('data-variant-id');
    } else {
      bisButton.setAttribute('data-variant-id', event.target.value);
    }
  });

  window.addEventListener('load', () => document.querySelector('input[name="id"]')?.dispatchEvent(new Event('change', { bubbles: true })));
  document.addEventListener('quickview:loaded', (event) => {
    const button = document.querySelector(`[data-product-url="${event.detail.productUrl}"] .BIS_trigger`);
    button?.parentElement.querySelector('input[name="id"]').dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Quick fix for product gallery dot nav not matching gallery carousel.
  function fixMediaDots() {
    if (matchMedia('(min-width: 1024px)').matches) return;

    // find all media thumbnails
    document.querySelectorAll('.product__thumbnails-list').forEach((thumbList) => {
      // find all visible media within the gallery
      const visibleMedia = thumbList
        .closest('.product__media-container')
        .querySelectorAll('.product__media-list .product__media:not(.product__media--variant:not(:first-child))');

      // show thumbnails that have corresponding media
      // thumbList.querySelectorAll(`.product__thumbnail:nth-of-type(-n+${visibleMedia.length + 1})`).forEach((el) => (el.style.display = ''));
      // ^-- might need this in the future

      // hide thumbnails that don't have corresponding media
      thumbList.querySelectorAll(`.product__thumbnail:nth-of-type(1n+${visibleMedia.length + 1})`).forEach((el) => (el.style.display = 'none'));

      // temp fix for gallery not going to the first slide on variant change
      const mediaGallery = thumbList.closest('media-gallery');
      mediaGallery?.productForm?.addEventListener('variant:change', () => mediaGallery.sliderGallery.select(1));
    });
  }

  fixMediaDots();
  window.addEventListener('resize', theme.utils.debounce(fixMediaDots, 300));
}); // DOMContentLoaded

class PDProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    fetch(this.getAttribute('data-url'))
      .then((response) => response.text())
      .then((responseText) => {
        const sectionInnerHTML = new DOMParser().parseFromString(responseText, 'text/html').querySelector('.shopify-section');

        if (sectionInnerHTML === null) return;

        const recommendations = sectionInnerHTML.querySelector('pd-product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.dispatchEvent(new CustomEvent('recommendations:loaded'));
        } else {
          this.closest('.shopify-section').remove();
          this.dispatchEvent(new CustomEvent('is-empty'));
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('pd-product-recommendations', PDProductRecommendations);

class PDRecentlyViewed extends HTMLElement {
  constructor() {
    super();

    if (!theme.config.hasLocalStorage) {
      this.hidden = true;
      return;
    }
  }

  connectedCallback() {
    fetch(this.getAttribute('data-url') + this.getQueryString())
      .then((response) => response.text())
      .then((responseText) => {
        const sectionInnerHTML = new DOMParser().parseFromString(responseText, 'text/html').querySelector('.shopify-section');

        const recommendations = sectionInnerHTML.querySelector('pd-recently-viewed');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.dispatchEvent(new CustomEvent('recentlyViewed:loaded'));
        } else {
          this.closest('.recently-section')?.remove();
          this.dispatchEvent(new CustomEvent('is-empty'));
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getQueryString() {
    let recentlyViewed = '[]';
    if (theme.config.hasLocalStorage) {
      recentlyViewed = window.localStorage.getItem(`${theme.settings.themeName}:recently-viewed`) || '[]';
    }

    const items = new Set(JSON.parse(recentlyViewed));
    if (this.hasAttribute('data-product-id')) {
      items.delete(parseInt(this.getAttribute('data-product-id')));
    }
    return Array.from(items.values(), (item) => `id:${item}`)
      .slice(0, this.hasAttribute('data-limit') ? parseInt(this.getAttribute('data-limit')) : 4)
      .join(' OR ');
  }
}

customElements.define('pd-recently-viewed', PDRecentlyViewed);
